import styles from './NoteUI.module.scss';

const NoteUI = ({ note, className = '' }) => {
  return (
    <div className={`${styles.note} ${className}`}>
      <span className={styles.noteLabel}>Note:</span>
      <span className={styles.noteText}>{note}</span>
    </div>
  );
};

export default NoteUI;
